import React from 'react'

const PostFooter = () => (
  <hr className="Post__Footer"></hr>
)

export default PostFooter
